import { frontendURL } from 'dashboard/helper/URLHelper.js';
import OnlineVisitorsPage from './pages/OnlineVisitorsPage.vue';

const onlineVisitorsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/online-visitors'),
      name: 'online_visitors_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: OnlineVisitorsPage,
    },
  ],
};

export default onlineVisitorsRoutes;